var _a;
import { z } from 'zod';
export class BaseError extends Error {
    constructor(message, errorCode) {
        super(message);
        this.errorCode = errorCode;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
export class BadRequestError extends BaseError {
}
export class UnauthorizedError extends BaseError {
}
export class ForbiddenError extends BaseError {
}
export class NotFoundError extends BaseError {
}
export class ConflictError extends BaseError {
}
export class ValidationError extends BaseError {
    constructor(message, errors) {
        super(message);
        this.errors = errors;
    }
}
_a = ValidationError;
(() => {
    // biome-ignore lint/complexity/noThisInStatic: <explanation>
    _a.prototype.name = 'ValidationError';
})();
export class TimeoutError extends Error {
    constructor(message) {
        super(message);
        this.name = 'TimeoutError';
    }
}
export const UserSchema = z.object({
    id: z.number(),
    name: z.string(),
    email: z.string(),
    password: z.string(),
});
//# sourceMappingURL=type.js.map